// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"circle","attrs":{"cx":12,"cy":12,"r":10,"stroke":"#000","strokeWidth":"props.strokeWidth","fill":"none"}},{"tag":"path","attrs":{"stroke":"#000","d":"M6.77539 9.04812C7.8058 7.22821 9.75958 6 12.0002 6M6.00391 12.2091L6.00391 12.1328","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"highlight-1"},"children":[{"tag":"circle","attrs":{"id":"fill1","cx":12,"cy":12,"r":10,"fill":"props.fillColor1","mask":"props.overlapMaskUrl_fill1"}},{"tag":"circle","attrs":{"id":"stroke1","cx":12,"cy":12,"r":10,"stroke":"props.strokeColor1","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6.77539 9.04812C7.8058 7.22821 9.75958 6 12.0002 6M6.00391 12.2091L6.00391 12.1328","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Highlight1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'highlight-1',
    ref,
    icon: element,
  },
));

Highlight1Icon.displayName = 'Highlight1Icon';

export default Highlight1Icon;
